import React, { useContext, useEffect } from "react";
import { FilterDialogContext } from "web/react/components/filter-redesign/filter-dialog/filter-dialog";

interface FilterDialogScreenProps {
    title: string;
    children?: React.ReactNode;
    showBackButton?: boolean;
    onBack?(): void;
}

export function FilterDialogScreen({
    title,
    showBackButton = true,
    onBack,
    children,
}: FilterDialogScreenProps): JSX.Element {
    const { setTitle, setOnBack, setShowBackButton } = useContext(FilterDialogContext);

    useEffect(() => {
        setShowBackButton(showBackButton);
    }, [showBackButton, setShowBackButton]);

    useEffect(() => {
        setTitle(title);
    }, [title, setTitle]);

    useEffect(() => {
        setOnBack(() => onBack);
    }, [setOnBack, onBack]);

    return <>{children}</>;
}
